import { graphql, useStaticQuery } from "gatsby";

export function useSiteMetadata() {
    const site = useStaticQuery(graphql`
        query UseSiteMetadata {
            allSite {
                nodes {
                    siteMetadata {
                        ...SiteMetadataFields
                    }
                }
            }
        }
    `).allSite.nodes[0].siteMetadata;

    return site;
}
